import PurchaseContainer from "@features/dashboard/components/PurchaseContainer";
import type { ProductType } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import { useLocalSearchParams } from "expo-router";

const PurchaseRoute = () => {
	const { productType, explicitProductNumericId, explicitProductId } =
		useLocalSearchParams<{
			productType: ProductType;
			explicitProductNumericId: string;
			explicitProductId?: string;
		}>();

	return (
		<Box flex={1}>
			<Box flex={1}>
				<PurchaseContainer
					productType={productType}
					explicitProductNumericId={Number(explicitProductNumericId)}
					explicitProductId={explicitProductId}
				/>
			</Box>
		</Box>
	);
};

export default PurchaseRoute;
